import { youtubeNativeStationTooltipMessage } from '@app/components/stations/station-messages';
import { isYoutubeNativeStation } from '@app/core/stations/helpers';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { Station } from '@app/core/types/stations';

/** YouTube brand red used for the native-station badge icon. */
const YOUTUBE_BRAND_COLOR = '#FF0000';

interface StatusAvatarYoutubeBadgeProps {
  station: Station;
  compact: boolean;
}

/**
 * Small YouTube icon badge shown at the top-right corner of the status avatar
 * for stations that use the YouTube Native integration.
 */
export function StatusAvatarYoutubeBadge({ station, compact }: StatusAvatarYoutubeBadgeProps) {
  const { $t } = useIntl();

  if (!isYoutubeNativeStation(station)) {
    return null;
  }

  return (
    <Tooltip title={$t(youtubeNativeStationTooltipMessage)} placement="top">
      <Box
        sx={{
          position: 'absolute',
          top: compact ? -3 : -4,
          right: compact ? -3 : -4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: compact ? 16 : 20,
          height: compact ? 16 : 20,
          borderRadius: '50%',
          bgcolor: 'background.paper',
          boxShadow: 1,
        }}
      >
        <YouTubeIcon
          sx={{
            fontSize: compact ? '0.75rem' : '0.875rem',
            color: YOUTUBE_BRAND_COLOR,
          }}
        />
      </Box>
    </Tooltip>
  );
}
